<template>
  <div>
    <div
      class="feedbar sticky-top"
      style="display:flex;align-items:stretch;justify-content:space-between"
    >
      <div
        class="navbar-logo ml-3"
        style="display:flex;align-items:center;cursor:pointer"
        @click="$emit('navbar-logo-clicked')"
      >
        <img
          src="../assets/cabinet-logo-cab.png"
          style="height:30px;"
        />
        <div
          class="ml-1 mt-2"
          style="font-size:28px;font-weight:bold;color:#50557d;line-height:1em"
        >Cabinet</div>
      </div>
      <div
        class="navbar-buttons mr-3"
        style="display:flex;align-items:center"
      >
        <div
          class="navbar-button cab-color bg-transparent mr-3"
          style="display:flex;align-items:center"
          @click="$emit('search-clicked')"
        >
          <font-awesome-icon
            icon="search"
            style="font-size:22px"
          />
          <span class="navbar-button-text ml-2">Search</span>
        </div>
        <div
          class="navbar-button cab-color bg-transparent ml-2 mr-2"
          style="display:flex;align-items:center"
          @click="$emit('new-note-clicked')"
        >
          <!-- <font-awesome-icon icon="far-sticky-note" /> -->
          <font-awesome-icon
            :icon="['far','sticky-note']"
            style="font-size:24px"
            class="cab-color"
          />
          <span class="navbar-button-text ml-2">New Note</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Feedbar",
  components: {},
  methods: {
    navbarClicked() {
      this.$emit("navbar-clicked");
    }
  }
};
</script>

<style scoped>
.cab-color {
  color: #50557d;
}

.feedbar {
  height: 60px;
  background-color: white;
  border-bottom: 1px solid gainsboro;
  pointer-events: all;
}

.navbar-logo {
  pointer-events: all;
}

.navbar-button {
  cursor: pointer;
}

.navbar-button-text {
  display: none;
}

@media (min-width: 500px) {
  .navbar-button-text {
    display: inline;
  }
}

@media (min-width: 768px) {
  .navbar-logo {
    pointer-events: none;
  }
}
</style>
